<template>
    <div>
        <Select v-if="flag" v-model="selectValue" 
            @on-change="onchange"
            :label-in-value="true"
            :changeValue="changeValue"
            :placeholder="placeholder"
            :filterable="filterable">
            <Option v-for="(item, index) in Arrs" :key="index" :value="item.value.toString()">{{item.label}}</Option>
        </Select>
        <!-- <select v-model="value" @change="onchange">
            <option v-for="(item, index) in Arrs" :key="index" :value="item.value.toString()">{{item.label}}</option>
        </select> -->
    </div>
</template>
<script>
export default {
    name: 'testRool',
    data() {
        return {
            selectValue:'',
            flag: true
        }
    },
    props: {
        Arrs: {
            type: Array
        },
        value: {
            type: [String, Number],
            default: ''
        },
        placeholder: String,
        filterable: Boolean,
        changeValue: {
            type: [String, Number]
        },
    },
    watch:{
        Arrs() {
            this.selectValue = this.value;
            this.flag = false;
            setTimeout(() => {
                this.flag = true;
            }, 1);
        }
    },
    methods: {
        onchange(val) {
            // console.log(val);
            this.$emit('on-change', val);
        }
    },
    mounted() {
        this.selectValue = this.value;
        this.flag = false;
        setTimeout(() => {
            this.flag = true;
        }, 1);
    }
}
</script>



// WEBPACK FOOTER //
// src/views/main-components/table/tests.vue